import { FunctionComponent, ReactNode } from 'react';
import { Box, Text } from '@chakra-ui/react';

type ReviewFieldProps = {
  label: string;
  value: ReactNode;
};

export const ReviewField: FunctionComponent<ReviewFieldProps> = ({
  label,
  value,
}) => (
  <Box bg="gray.50" borderRadius="md" px={4} py={3}>
    <Text
      fontSize="11px"
      fontWeight="semibold"
      color="gray.500"
      letterSpacing="wide"
      textTransform="uppercase"
    >
      {label}
    </Text>
    <Text fontSize="15px" fontWeight="semibold" color="text.main" mt={1}>
      {value}
    </Text>
  </Box>
);
